import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bd674ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_3 = { class: "card-header border-bottom" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_8 = { class: "svg-icon svg-icon-2" }
const _hoisted_9 = { class: "card-body p-9" }
const _hoisted_10 = { class: "mb-10" }
const _hoisted_11 = { class: "row g-6" }
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_14 = { class: "section-header mb-6" }
const _hoisted_15 = { class: "fw-bold text-dark mb-1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed border-gray-300" }, null, -1))
const _hoisted_17 = { class: "info-item mb-4" }
const _hoisted_18 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_19 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_20 = { class: "fw-bold text-gray-800" }
const _hoisted_21 = { class: "info-item mb-4" }
const _hoisted_22 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_23 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_24 = { class: "fw-bold text-gray-700 text-hover-primary" }
const _hoisted_25 = { class: "info-item mb-4" }
const _hoisted_26 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_27 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "col-lg-6" }
const _hoisted_30 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_31 = { class: "section-header mb-6" }
const _hoisted_32 = { class: "fw-bold text-dark mb-1" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed border-gray-300" }, null, -1))
const _hoisted_34 = { class: "info-item mb-4" }
const _hoisted_35 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_36 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_37 = { class: "fw-bold text-gray-800" }
const _hoisted_38 = { class: "info-item mb-4" }
const _hoisted_39 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_40 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_41 = { class: "fw-bold text-gray-800" }
const _hoisted_42 = { class: "info-item mb-4" }
const _hoisted_43 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_44 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_45 = ["href"]
const _hoisted_46 = { class: "info-item" }
const _hoisted_47 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_48 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_49 = { class: "fw-bold text-gray-800" }
const _hoisted_50 = { class: "mb-10" }
const _hoisted_51 = { class: "section-header mb-6" }
const _hoisted_52 = { class: "fw-bold text-dark mb-1" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed border-gray-300" }, null, -1))
const _hoisted_54 = { class: "row g-6" }
const _hoisted_55 = { class: "col-12" }
const _hoisted_56 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_57 = { class: "row g-10" }
const _hoisted_58 = { class: "col-md-6" }
const _hoisted_59 = { class: "info-item" }
const _hoisted_60 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_61 = { class: "info-value p-3 bg-white rounded border border-gray-200 text-center" }
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = { class: "info-item" }
const _hoisted_64 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_65 = { class: "info-value p-3 bg-white rounded border border-gray-200 text-center" }
const _hoisted_66 = { class: "badge badge-dark fw-bold" }
const _hoisted_67 = { class: "row g-10" }
const _hoisted_68 = { class: "col-md-6" }
const _hoisted_69 = { class: "info-item" }
const _hoisted_70 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_71 = { class: "info-value p-3 bg-white rounded border border-gray-200 text-center" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_73 = { class: "fs-6 fw-bold form-label" }
const _hoisted_74 = { class: "mt-4" }
const _hoisted_75 = { class: "indicator-label" }
const _hoisted_76 = { class: "indicator-progress" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_78 = { class: "col-md-6" }
const _hoisted_79 = { class: "info-item" }
const _hoisted_80 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_81 = { class: "col-lg-8 fv-row" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select a badge", -1))
const _hoisted_83 = ["value"]
const _hoisted_84 = { class: "mt-3 d-flex align-items-center gap-3" }
const _hoisted_85 = ["src"]
const _hoisted_86 = { class: "fw-bold" }
const _hoisted_87 = { class: "mt-4" }
const _hoisted_88 = ["disabled"]
const _hoisted_89 = { class: "indicator-label" }
const _hoisted_90 = { class: "indicator-progress" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_92 = { class: "fv-plugins-message-container" }
const _hoisted_93 = { class: "fv-help-block" }
const _hoisted_94 = { class: "mb-10" }
const _hoisted_95 = { class: "section-header mb-6" }
const _hoisted_96 = { class: "fw-bold text-dark mb-1" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed border-gray-300" }, null, -1))
const _hoisted_98 = { class: "row g-6" }
const _hoisted_99 = { class: "col-lg-6" }
const _hoisted_100 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_101 = { class: "info-item mb-4" }
const _hoisted_102 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_103 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_104 = { class: "text-gray-800" }
const _hoisted_105 = { class: "info-item mb-4" }
const _hoisted_106 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_107 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_108 = { class: "text-gray-800" }
const _hoisted_109 = { class: "info-item mb-4" }
const _hoisted_110 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_111 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_112 = { class: "text-gray-800" }
const _hoisted_113 = { class: "info-item" }
const _hoisted_114 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_115 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_116 = { class: "text-gray-800" }
const _hoisted_117 = { class: "info-item mb-4" }
const _hoisted_118 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_119 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_120 = { class: "text-gray-800" }
const _hoisted_121 = { class: "col-lg-6" }
const _hoisted_122 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_123 = { class: "info-item mb-4" }
const _hoisted_124 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_125 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_126 = { class: "text-gray-800" }
const _hoisted_127 = { class: "info-item mb-4" }
const _hoisted_128 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_129 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_130 = { class: "text-gray-800" }
const _hoisted_131 = { class: "info-item" }
const _hoisted_132 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_133 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_134 = { class: "text-gray-800" }
const _hoisted_135 = { class: "mb-0" }
const _hoisted_136 = { class: "section-header mb-6" }
const _hoisted_137 = { class: "fw-bold text-dark mb-1" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed border-gray-300" }, null, -1))
const _hoisted_139 = { class: "card shadow-sm border border-gray-200" }
const _hoisted_140 = { class: "card-body p-0" }
const _hoisted_141 = { class: "table-responsive" }
const _hoisted_142 = { class: "table table-hover align-middle fs-6 gy-4 mb-0" }
const _hoisted_143 = { class: "bg-gray-100" }
const _hoisted_144 = { class: "text-start fw-bold text-gray-700 text-uppercase gs-0" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "ps-6 border-bottom" }, "#", -1))
const _hoisted_146 = { class: "border-bottom" }
const _hoisted_147 = { class: "border-bottom" }
const _hoisted_148 = { class: "border-bottom" }
const _hoisted_149 = { class: "border-bottom" }
const _hoisted_150 = { class: "pe-6 text-center border-bottom" }
const _hoisted_151 = { class: "ps-6 fw-bold text-gray-500" }
const _hoisted_152 = { class: "fw-semibold text-gray-800" }
const _hoisted_153 = { class: "text-gray-600" }
const _hoisted_154 = { class: "text-gray-600" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600" }, /*#__PURE__*/_toDisplayString('Marketer'))
], -1))
const _hoisted_156 = { class: "pe-6 text-center" }
const _hoisted_157 = { key: 0 }
const _hoisted_158 = {
  colspan: "5",
  class: "text-center text-gray-500 py-8"
}
const _hoisted_159 = { class: "fw-semibold fs-5" }
const _hoisted_160 = { class: "d-flex justify-content-between align-items-center p-6 border-top bg-gray-50" }
const _hoisted_161 = ["disabled"]
const _hoisted_162 = { class: "fw-semibold text-gray-600" }
const _hoisted_163 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_ctx.can('read', 'users') && _ctx.office)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.translate('officeDetails')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_ctx.can('create', 'users'))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-primary me-3",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('offices-editing')))
                    }, [
                      _createElementVNode("span", _hoisted_8, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.translate('updateOffice')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn btn-light",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('backToList')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.translate('basicInfoBorker')), 1),
                      _hoisted_16
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('officeName')) + ":", 1),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.office?.business_account_info.name), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.translate('borkerPhone')) + ":", 1),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("a", _hoisted_24, _toDisplayString(_ctx.office?.business_account_info.phone), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.translate('borkerEmail')) + ":", 1),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("a", {
                          href: `mailto:${_ctx.office?.business_account_info.email}`,
                          class: "fw-bold text-gray-700 text-hover-primary"
                        }, _toDisplayString(_ctx.office?.business_account_info.email), 9, _hoisted_28)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("h3", _hoisted_32, _toDisplayString(_ctx.translate('basicInfoUser')), 1),
                      _hoisted_33
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.translate('name')) + ":", 1),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.office.name), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.translate('phone')) + ":", 1),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.office.phone), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.translate('email')) + ":", 1),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("a", {
                          href: `mailto:${_ctx.office.email}`,
                          class: "fw-bold text-gray-700 text-hover-primary"
                        }, _toDisplayString(_ctx.office.email), 9, _hoisted_45)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.translate('createdAt')) + ":", 1),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.office.createdAt), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("h3", _hoisted_52, _toDisplayString(_ctx.translate('statusInfo')), 1),
                _hoisted_53
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.translate('accountStatus')) + ":", 1),
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("span", {
                              class: _normalizeClass(`badge ${
                            _ctx.office.is_active
                              ? 'badge-success'
                              : 'badge-secondary'
                          } fw-bold`)
                            }, _toDisplayString(_ctx.office.is_active
                              ? _ctx.translate('active')
                              : _ctx.translate('inactive')), 3)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.translate('officeType')) + ":", 1),
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.office.isOffice
                              ? _ctx.translate('businessAccount')
                              : _ctx.translate('individualAccount')), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.translate('verificationStatus')) + ":", 1),
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("span", {
                              class: _normalizeClass(`badge ${
                            _ctx.office?.business_account_info.isVerifiedOffice
                              ? 'badge-success'
                              : 'badge-secondary'
                          } fw-bold`)
                            }, _toDisplayString(_ctx.office?.business_account_info.isVerifiedOffice
                              ? _ctx.translate('verified')
                              : _ctx.translate('unverified')), 3)
                          ])
                        ]),
                        _hoisted_72,
                        _createElementVNode("p", _hoisted_73, _toDisplayString(_ctx.office?.business_account_info.isVerifiedOffice
                          ? 'إلغاء توثيق هذا الوسيط ؟'
                          : 'توثيق هذا الوسيط ؟'), 1),
                        _createElementVNode("div", _hoisted_74, [
                          (_ctx.can('update', 'users'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                ref: "submitButton",
                                type: "button",
                                class: "btn btn-primary",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggledVerificationStatus(_ctx.office)))
                              }, [
                                _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.office?.business_account_info.isVerifiedOffice
                              ? 'unverified'
                              : 'verified'), 1),
                                _createElementVNode("span", _hoisted_76, [
                                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + "... ", 1),
                                  _hoisted_77
                                ])
                              ], 512))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.translate('badges')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_81, [
                          _withDirectives(_createElementVNode("select", {
                            name: "badges",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedBadgeId) = $event)),
                            class: "form-select"
                          }, [
                            _hoisted_82,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.badges, (badge) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: badge.id,
                                value: badge.id
                              }, _toDisplayString(badge.titleEn + ' - ' + badge.titleAr), 9, _hoisted_83))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.selectedBadgeId]
                          ]),
                          _createElementVNode("div", _hoisted_84, [
                            _createElementVNode("img", {
                              src: _ctx.selectedBadge?.icon || _ctx.thumbnail,
                              alt: "",
                              style: {"width":"40px","height":"40px","object-fit":"contain"}
                            }, null, 8, _hoisted_85),
                            _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.selectedBadge?.titleEn +
                          ' - ' +
                          _ctx.selectedBadge?.titleAr), 1)
                          ]),
                          _createElementVNode("div", _hoisted_87, [
                            (_ctx.can('update', 'users'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  ref: "submitButton",
                                  type: "button",
                                  class: "btn btn-primary",
                                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSubmitUpdate && _ctx.onSubmitUpdate(...args))),
                                  disabled: !_ctx.selectedBadgeId
                                }, [
                                  _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.translate('updateBadge')), 1),
                                  _createElementVNode("span", _hoisted_90, [
                                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + "... ", 1),
                                    _hoisted_91
                                  ])
                                ], 8, _hoisted_88))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_92, [
                            _createElementVNode("div", _hoisted_93, [
                              _createVNode(_component_ErrorMessage, { name: "badges" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("h3", _hoisted_96, _toDisplayString(_ctx.translate('mediaInfo')), 1),
                _hoisted_97
              ]),
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.translate('website')) + ":", 1),
                      _createElementVNode("div", _hoisted_103, [
                        _createElementVNode("span", _hoisted_104, _toDisplayString(_ctx.office?.business_account_info?.website || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("label", _hoisted_106, _toDisplayString(_ctx.translate('facebook')) + ":", 1),
                      _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.office?.business_account_info?.facebook || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_109, [
                      _createElementVNode("label", _hoisted_110, _toDisplayString(_ctx.translate('whatsapp')) + ":", 1),
                      _createElementVNode("div", _hoisted_111, [
                        _createElementVNode("span", _hoisted_112, _toDisplayString(_ctx.office?.business_account_info?.whatsapp || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_113, [
                      _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.translate('instagram')) + ":", 1),
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.office?.business_account_info?.instagram || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_117, [
                      _createElementVNode("label", _hoisted_118, _toDisplayString(_ctx.translate('twitter')) + ":", 1),
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("span", _hoisted_120, _toDisplayString(_ctx.office?.business_account_info?.twitter || 'N/A'), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_121, [
                  _createElementVNode("div", _hoisted_122, [
                    _createElementVNode("div", _hoisted_123, [
                      _createElementVNode("label", _hoisted_124, _toDisplayString(_ctx.translate('registrationNumber')) + ":", 1),
                      _createElementVNode("div", _hoisted_125, [
                        _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.office?.business_account_info?.registrationNumber || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_127, [
                      _createElementVNode("label", _hoisted_128, _toDisplayString(_ctx.translate('location')) + ":", 1),
                      _createElementVNode("div", _hoisted_129, [
                        _createElementVNode("span", _hoisted_130, _toDisplayString(_ctx.office?.business_account_info?.location || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_131, [
                      _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.translate('mapUrl')) + ":", 1),
                      _createElementVNode("div", _hoisted_133, [
                        _createElementVNode("span", _hoisted_134, _toDisplayString(_ctx.office?.business_account_info?.mapUrl || 'N/A'), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_135, [
              _createElementVNode("div", _hoisted_136, [
                _createElementVNode("h3", _hoisted_137, _toDisplayString(_ctx.translate('linkedAccounts') + ' (' + _ctx.employeeCount + ')'), 1),
                _hoisted_138
              ]),
              _createElementVNode("div", _hoisted_139, [
                _createElementVNode("div", _hoisted_140, [
                  _createElementVNode("div", _hoisted_141, [
                    _createElementVNode("table", _hoisted_142, [
                      _createElementVNode("thead", _hoisted_143, [
                        _createElementVNode("tr", _hoisted_144, [
                          _hoisted_145,
                          _createElementVNode("th", _hoisted_146, _toDisplayString(_ctx.translate('name')), 1),
                          _createElementVNode("th", _hoisted_147, _toDisplayString(_ctx.translate('email')), 1),
                          _createElementVNode("th", _hoisted_148, _toDisplayString(_ctx.translate('phone')), 1),
                          _createElementVNode("th", _hoisted_149, _toDisplayString(_ctx.translate('accountType')), 1),
                          _createElementVNode("th", _hoisted_150, _toDisplayString(_ctx.translate('status')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (employee, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: employee.id,
                            class: "border-bottom border-gray-200"
                          }, [
                            _createElementVNode("td", _hoisted_151, _toDisplayString((_ctx.currentPage - 1) * _ctx.pageSize + index + 1), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_152, _toDisplayString(employee.name ||
                            employee.first_name + ' ' + employee.last_name), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_153, _toDisplayString(employee.email), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_154, _toDisplayString(employee.phone), 1)
                            ]),
                            _hoisted_155,
                            _createElementVNode("td", _hoisted_156, [
                              _createElementVNode("span", {
                                class: _normalizeClass(`badge ${
                            employee.is_active
                              ? 'badge-success'
                              : 'badge-secondary'
                          } fw-semibold`)
                              }, _toDisplayString(employee.is_active
                              ? _ctx.translate('active')
                              : _ctx.translate('inactive')), 3)
                            ])
                          ]))
                        }), 128)),
                        (_ctx.employees.length === 0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_157, [
                              _createElementVNode("td", _hoisted_158, [
                                _createElementVNode("div", _hoisted_159, _toDisplayString(_ctx.translate('noEmployeesFound')), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_160, [
                    _createElementVNode("button", {
                      class: "btn btn-light btn-sm",
                      disabled: _ctx.currentPage === 1,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onPageChange('previous')))
                    }, " ← " + _toDisplayString(_ctx.translate('previous')), 9, _hoisted_161),
                    _createElementVNode("div", _hoisted_162, _toDisplayString(_ctx.translate('page')) + " " + _toDisplayString(_ctx.currentPage) + " " + _toDisplayString(_ctx.translate('of')) + " " + _toDisplayString(Math.ceil(_ctx.totalItems / _ctx.pageSize)), 1),
                    _createElementVNode("button", {
                      class: "btn btn-light btn-sm",
                      disabled: !_ctx.isNext,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onPageChange('next')))
                    }, _toDisplayString(_ctx.translate('next')) + " → ", 9, _hoisted_163)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}